import { UserTokenService } from '../services/user-service/user-token.service';
import {versionLog} from "./update-constant.helper";
import {environment} from '../environments/environment';

export class LoginHelper {
  static forgetTokenAndGoToLoginPage(userTokenService: UserTokenService): void {
    userTokenService.removeToken();
    userTokenService.removeId();
    userTokenService.removeName();

    if (window.location.hostname === 'localhost') {
      window.location.href = environment.apiReportUrl + 'contacts/login';
    } else {
      window.location.pathname = '/contacts/login';
    }
  }

  static logout(userTokenService: UserTokenService): void {
    const token = userTokenService.getToken();

    if (!token) {
      return this.forgetTokenAndGoToLoginPage(userTokenService);
    }

    const queryParams = '?token=' + token;
    userTokenService.removeToken();
    userTokenService.removeId();
    userTokenService.removeName();
    userTokenService.removeLocale();
    localStorage.setItem('changelogSkipped', versionLog.currentVersion);
    sessionStorage.clear();

    if (window.location.hostname === 'localhost') {
      window.location.href = environment.apiReportUrl + 'contacts/logout' + queryParams;
    } else {
      window.location.href = window.location.protocol + '//' + window.location.host + '/contacts/logout' + queryParams;
    }
  }
}
